
export default {
    
    name: 'usuarios',
    component: () => import(/* webpackChunkName: "Users" */ '@/modules/sievi/layouts/SieviLayout.vue'),
    children: [
        {
            path: '',
            name: 'users.home',
            component: () => import(/* webpackChunkName: "Users-list" */ '@/modules/sievi/views/administrador/users/List.vue'),
        },
        {
            path: 'crear',
            name: 'users.create',
            component: () => import(/* webpackChunkName: "Users-create" */ '@/modules/sievi/views/administrador/users/Create.vue'),
        },
        {
            path: 'editar/:id',
            name: 'users.edit',
            component: () => import(/* webpackChunkName: "Users-create" */ '@/modules/sievi/views/administrador/users/Edit.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id)
                }
            }
        },
        {
            path: 'contratos/:id',
            name: 'users.contracts',
            component: () => import(/* webpackChunkname: "Users-contract" */ '@/modules/sievi/views/administrador/users/contracts/List.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id)
                }
            }
        },
        {
            path: 'contratos/hfs/:id',
            name: 'users.contracts.hfs',
            component: () => import(/* webpackChunkname: "Users-contract-hfs" */ '@/modules/sievi/views/administrador/users/contracts/Hfs.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id)
                }
            }
        },
        {
            path: 'responsable/:id/:campusId/:hfsId/:programId/:teacherId',
            name: 'users.responsable.contracts',
            component: () => import(/* webpackChunkName: "Programs-teachers" */ '@/modules/sievi/views/responsable/contratos/List.vue'),
            props: ( route ) => {
                return {
                    id: Number(route.params.id),
                    campusId: Number(route.params.campusId),
                    hfsId: Number(route.params.hfsId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                }
            }
        },
        {
            path: 'auditor/:campusId/:programId/:teacherId',
            name: 'users.auditor.contracts',
            component: () => import(/* webpackChunkName: "Programs-teachers" */ '@/modules/sievi/views/auditor/contratos/List.vue'),
            props: ( route ) => {
                return {
                    campusId: Number(route.params.campusId),
                    programId: Number(route.params.programId),
                    teacherId: Number(route.params.teacherId),
                }
            }
        },
    //     {
    //         path: 'usuarios/crear',
    //         name: 'users.create',
    //         component: () => import(/* webpackChunkName: "Users-create" */ '@/modules/sievi/views/users/Create.vue'),
    //     },
    //     {
    //         path: 'usuarios/editar/:id',
    //         name: 'users.edit',
    //         component: () => import(/* webpackChunkName: "Users-edit" */ '@/modules/sievi/views/users/Edit.vue'),
    //         props: ( route ) => {
    //             return {
    //                 id: Number(route.params.id)
    //             }
    //         }
    //     },
    ],

}